import { createContext } from 'react';
var OverlayContext = /*#__PURE__*/createContext({
  setVisibleOverlayToParent: function setVisibleOverlayToParent() {}
});
export default OverlayContext;